module.exports = __webpack_public_path__ + "img/Grabner Rudolf.jpg";